import React from 'react';
import MissingGamesPage from '../features/games/missing/pages/MissingGamesPage';

const MissingGames: React.FC = () => <MissingGamesPage />;

export default MissingGames;
